export default "__VITE_ASSET__e59a05e2__"